import { NgModule } from '@angular/core';
import {
  ReviewEntryContainerComponent,
  ReviewOverviewContainerComponent,
  ReviewScoreContainerComponent,
  ReviewSingleContainerComponent,
  ReviewsModule,
} from '@innogy/reviews';
import { provideLazyLoad } from '@core/jss-utils';
import { CoreTranslateModule, provideTranslationLoader } from '@core/translate';

const namespace = 'reviewsFeature';

@NgModule({
  imports: [
    ReviewsModule,
    CoreTranslateModule,
    provideLazyLoad({
      Review: ReviewSingleContainerComponent,
      ReviewScoreWidget: ReviewScoreContainerComponent,
      ReviewEntry: ReviewEntryContainerComponent,
      ReviewOverview: ReviewOverviewContainerComponent,
    }),
  ],
  providers: [provideTranslationLoader(namespace, (path) => import(`${path}`))],
})
export class ReviewsLazyModule {}
